import axios from 'axios'

export default class IAFilterPost {
    /**
     * @param {Object} options This is an object to instanciate the load more
     * @param {String} options.post_type You have to provide the post type to load
     * @param {HTMLElement} options.item Provide the item to clone
     * @param {Number} options.page_to_load Number of page to load
     * @param {Number} options.per_page Number of element to display
     * @param {Array} options.tag Type of categories
     * @param {Number} options.maxpage Maximum of pages
     * @param {String} options.lang Provide the lang
     * @param {String} [options.image] Selector of the image
     * @param {String} [options.title] Selector of the title
     * @param {String} [options.excerpt] Selector of excerpt
     * @param {String} [options.date] Selector of date
     */
    constructor(
        options = {
            post_type: '',
            item : new HTMLElement,
            page_to_load: 0,
            per_page: 0,
            maxpage: 0,
            tag: [],
            lang: '',
            image: '',
            title: '',
            excerpt: '',
            date: '',
            list: new HTMLElement,
            label: '',
        }
    ) {
        this.options = options
        if(options.page_to_load <= options.maxpage){
            this.getPosts()
            document.querySelector('.ia-block-posts').dataset.page = options.page_to_load
            if(options.page_to_load == options.maxpage){
                //options.item.parentElement.parentElement.querySelector('.wp-block-buttons button').disabled = true;
            }
        }else{
            //options.item.parentElement.parentElement.querySelector('.wp-block-buttons button').disabled = true;
        }
    }

    async getPosts() {
        let url = '/wp-json/wp/v2/'+ this.options.post_type 
            + '?per_page='+ this.options.per_page 
            + '&page='+ this.options.page_to_load
            + '&lang=' + this.options.lang
            if(this.options.tag.length > 0){
                for(let i=0;i<this.options.tag.length;i++){
                    url += '&categories[]=' + this.options.tag[i]
                }
            }
        return await axios.get(url).then((response) => {
            let listResponse = response.data;
            const itemsToDisplay = [] 
            listResponse.forEach(item => {
                const link = item.link
                let clonedItem = this.options.item.cloneNode(true)
                clonedItem.querySelector(this.options.image).srcset = ''
                clonedItem.querySelector(this.options.image).src = ''
                
                if(this.options.title != undefined){
                    const title = item.title.rendered
                    clonedItem.querySelector(this.options.title).textContent = title
                }
                if(this.options.excerpt != undefined){
                    const excerpt = item.excerpt.rendered
                    clonedItem.querySelector(this.options.excerpt).innerHTML = excerpt
                }

                if(this.options.date != undefined){
                    const dateString = item.date
                    const date = new Date(dateString);
                    clonedItem.querySelector(this.options.date).innerHTML = date.getDate()+'.'+(date.getMonth() + 1)+'.'+date.getFullYear()
                }
                if(this.options.label != undefined){
                    const label = this.getCategory(item.categories[0]) 
                    label.then(labelName => {
                        clonedItem.querySelector(this.options.label).textContent = labelName
                        clonedItem.querySelector(this.options.label).dataset.termid = labelName
                    })
                }                  
                if(this.options.image != undefined){
                    const image = this.getImage(item.featured_media) 
                    image.then(imageSrc => {
                        clonedItem.querySelector(this.options.image).src = imageSrc
                        clonedItem.querySelectorAll('a').forEach(a=>{
                            a.href = link
                        })
                        itemsToDisplay.push(clonedItem);
                    })
                }                  
            });
            this.options.list.innerHTML = ''
            const spinnerContainer = document.createElement('li')
            spinnerContainer.classList.add('ia-block-loader')
            const spinner = document.createElement('span')
            spinner.classList.add('spinner')
            spinnerContainer.append(spinner)
            this.options.list.append(spinnerContainer)

            var loadArray = setInterval(() => {
                if(itemsToDisplay.length == listResponse.length){
                    console.log(response.headers)
                    this.updatePagination(response.headers['x-wp-totalpages'])
                    this.options.list.innerHTML = ''
                    itemsToDisplay.forEach(itemToDisplay=>{
                        this.options.list.append(itemToDisplay)
                    })
                    clearInterval(loadArray)
                }
            }, 50);
        })
    }

    async getImage(id) {
        return await axios.get('/wp-json/wp/v2/media/' + id).then((response) => {
            if(response.status == 200){
                let imageSize = response.data.media_details.sizes;
                imageSize = (imageSize.large)?imageSize.large:imageSize.full
                return imageSize.source_url
            }
        }).catch((error)=>{
        })
    }

    async getCategory(id) {
        return await axios.get('/wp-json/wp/v2/categories/' + id).then((response) => {
            let categoryName = response.data.name;
            return categoryName
        }).catch((error)=>{
        })
    }

    updatePagination(header) {
        console.log(header)
        document.querySelector('.is-pagination .pagination-max').textContent = header
        document.getElementById('pageNumber').max = header
        const buttonNext = document.querySelector('.pagination-next button');
        const buttonPrev = document.querySelector('.pagination-prev button');
        if(header == 1){
           buttonNext.classList.add('disabled')
            buttonPrev.classList.add('disabled')
        }else{
            if(Number(document.querySelector('.ia-block-posts').dataset.page) == 1){
                buttonPrev.classList.add('disabled')
                buttonNext.classList.remove('disabled')
            }else if(Number(document.querySelector('.ia-block-posts').dataset.page) == header){
                buttonNext.classList.add('disabled')
                buttonPrev.classList.remove('disabled')
            }else{
                buttonPrev.classList.remove('disabled')
                buttonNext.classList.remove('disabled')
            }
        }
    }
}